export default () => {
    window.addEventListener('load', () => {
        const initFreshChatCTA = document.querySelector('#initiateFreshChat');
        if (initFreshChatCTA) {
            const loader = document.querySelector('.fresh-chat-loader');
            initFreshChatCTA.addEventListener('click', () => {
                initFreshChatCTA.classList.add('rotate');
                const store = initFreshChatCTA.getAttribute('data-store-id');
                loader.style.display = 'block';
                function initFreshChat() {
                    if (window && window.fcWidget) {
                        window.fcWidget.init({
                            token: "25533157-983d-4e2c-bfe1-f26fbb00242f",
                            host: "https://wchat.freshchat.com",
                            widgetUuid: store ==="AU_NRMA" ? "c770d721-6d12-46db-b7ce-67e6ceb6ff7b" : undefined,
                            siteId: store,
                            open: true,
                        });
                        window.fcWidget.on("widget:loaded", () => {
                            initFreshChatCTA.style.display = 'none';
                            loader.style.display = 'none';
                        });
                    }
                }
                (function (d, id) {
                    var fcJS;
                    if (d.getElementById(id)) {
                        initFreshChat();
                        return;
                    }
                    fcJS = d.createElement('script');
                    fcJS.id = id;
                    fcJS.async = true;
                    fcJS.src = 'https://wchat.freshchat.com/js/widget.js';
                    fcJS.onload = initFreshChat;
                    d.head.appendChild(fcJS);
                }(document, 'freshchat-js-sdk'));
            })

        }
    });
};